'use strict';
const throttle = require('throttle-debounce/throttle');

function check() {
    if ($(window).width() > 768) {
        $('.biography__details').mCustomScrollbar({
            axis: 'y'
        });
        $('.biography__modal-col--left').mCustomScrollbar({
            axis: 'y'
        });
    } else {
        $('.biography__details').mCustomScrollbar('destroy');
        $('.biography__modal-col--left').mCustomScrollbar('destroy');
    }
}

document.addEventListener('DOMContentLoaded', () => {

    const biography = document.querySelector('.js-biography-fancybox'),
        exists = typeof(biography) != 'undefined' && biography != null;

    if (exists) {
        $(window).on("resize", throttle(300, check));

        $('.js-biography-fancybox').fancybox({
            loop: false,
            infobar: false,
            toolbar: false,
            touch: false,
            transitionDuration: 0,
            baseTpl: '<div class="fancybox-container fancybox-container--biography" role="dialog" tabindex="-1">' +
                '<div class="fancybox-bg"></div>' +
                '<div class="fancybox-inner">' +
                '<div class="fancybox-stage"></div>' +
                '<div class="fancybox-navigation">{{arrows}}</div>' +
                '</div>' +
                '</div>',
            btnTpl: {
                arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"></button>',
                arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"></button>',
                smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"></button>'
            },
            beforeShow: (instance, slide) => {
                check();
            },
            afterShow: (instance, slide) => {
                let biography = document.querySelector('.fancybox-content'),
                    navigation = document.querySelector('.fancybox-navigation');

                navigation.classList.add('visible');
            }
        });

    };
});



// WEBPACK FOOTER //
// ./frontend/components/biography/biography.js